exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.amentities-container {\r\n    margin-top: 0;\r\n    width: 100%;\r\n    background-color: white;\r\n    margin-bottom: 20px;\r\n    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\ndiv.container {\r\n    max-width: 900px;\r\n    width: 100%;\r\n}\r\n\r\ndiv.section-wrapper {\r\n    margin-top: 20px;\r\n    max-width: 900px;\r\n    width: 100%;\r\n    display: block;\r\n}\r\n\r\ndiv.img-wrapper {\r\n    display: inline-block;\r\n    margin: 0;\r\n    vertical-align: top;\r\n}\r\n\r\ndiv.text-wrapper {\r\n    display: inline-block;\r\n    margin-left: 20px;\r\n    text-align: left;\r\n    max-width: 600px;\r\n    width: 100%;\r\n}\r\n\r\np.title-text {\r\n    font-size: 24px;\r\n    font-family: \"Myriad Pro\";\r\n    color: #2b2b2b;\r\n    padding: 13px 0 0 0;\r\n    margin: 0;\r\n}\r\n\r\np.desc-text {\r\n    color: #7a7a7a;\r\n    font-size: 14px;\r\n    font-family: \"Myriad Pro\";\r\n    letter-spacing: -0.025em;\r\n}\r\n\r\ndiv.separator {\r\n    max-width: 600px;\r\n    width: 100%;\r\n    height: 1px;\r\n    background-color: #c0c0c0;\r\n    margin: 20px 0 20px 0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/amenities/amenities.component.css
// module id = 746
// module chunks = 1